(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cig-lid-offer')) {
  customElements.define('cig-lid-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      const select = this.querySelector('select');
      select.addEventListener('change', event => event.stopPropagation());
      if (!select.options.length) { this.hidden = true; return; }
      button.addEventListener('click', async () => {
        if (this.busy) return;
        this.busy = true;
        button.disabled = true;
        button.textContent = 'Agregando...';
        const error = this.querySelector('[role="alert"]');
        error.textContent = '';
        let added = false;
        try {
          const drawer = this.closest('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') throw new Error('No se pudo actualizar el carrito. Recarga la pagina.');
          const sections = drawer.getSectionsToRender().map(section => section.id);
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }], sections, sections_url: window.location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'No pudimos agregar la tapa. Intenta nuevamente.');
          added = true;
          if (!result.sections || sections.some(id => !result.sections[id])) throw new Error('La tapa se agrego. Recarga la pagina para actualizar el carrito.');
          drawer.renderContents(result);
          requestAnimationFrame(() => {
            const target = drawer.querySelector('.cig-lid-offer__add') || drawer.querySelector('#CartDrawer-Checkout');
            if (target) target.focus();
          });
        } catch (failure) {
          error.textContent = failure.message || 'No pudimos actualizar el carrito. Revisa tu conexion.';
        } finally {
          if (this.isConnected) {
            button.disabled = added;
            button.textContent = added ? 'Tapa agregada' : 'Agregar \u00b7 $2.990';
          }
          this.busy = false;
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
